module.exports = __webpack_public_path__ + "img/orange_068.246c7166.png";